<template>
  <div>
    <div v-if="!forgotPassword && !resendVerification">
      <b-alert show v-if="successMessage" variant="success">
        {{ successMessage }}
      </b-alert>
      <el-form
        :model="loginRequest"
        label-position="top"
        @submit.prevent.native="login"
      >
        <el-form-item label="邮箱地址">
          <el-input v-model="loginRequest.username" :required="true"></el-input>
          <div>
            <b-alert show v-if="errors.username" variant="danger">
              <span
                v-for="(error, index) in errors.username"
                v-bind:key="index"
              >
                {{ error }}
              </span>
            </b-alert>
          </div>
        </el-form-item>
        <el-form-item label="密 码">
          <el-input
            type="password"
            v-model="loginRequest.password"
            @keyup.enter.native="login"
            autocomplete="off"
          ></el-input>
          <b-alert show v-if="errors.password" variant="danger">
            <span v-for="(error, index) in errors.password" v-bind:key="index">
              {{ error }}
            </span>
          </b-alert>
        </el-form-item>
        <el-form-item>
          <el-button @click="login" class="float-right">登 录</el-button>
          <a href="" @click.prevent="forgotPassword = true">
            忘记密码?
          </a>
          &nbsp;/&nbsp;
          <a href="" @click.prevent="resendVerification = true">
            找不到激活邮件？
          </a>
        </el-form-item>
      </el-form>

      <div>
        <b-alert show v-if="this.message" variant="danger">
          {{ this.message }}
        </b-alert>
      </div>
      <div class="text-center desktopView">
        <a
          title="微信登录"
          href="https://open.weixin.qq.com/connect/qrconnect?appid=wx957a277b11a4e554&redirect_uri=https://www.99huaren.com/wechat/login&response_type=code&scope=snsapi_login&state=user_id#wechat_redirecdt"
        >
          <img
            src="/wechat.ico"
            loading="lazy"
            title="微信登录"
            height="45px"
            alt="微信登录"
          />
          微信登录
        </a>
      </div>
    </div>
    <div v-if="forgotPassword">
      <el-form
        :model="loginRequest"
        label-position="top"
        @submit.prevent.native="resetPassword"
      >
        <el-form-item label="邮箱地址">
          <el-input v-model="email" :required="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetPassword">发送密码重置链接</el-button>
          <el-button @click="forgotPassword = false" class="float-right"
            >登录页面</el-button
          >
        </el-form-item>
      </el-form>
      <div>
        <b-alert show v-if="this.message" variant="danger">
          {{ this.message }}
        </b-alert>
      </div>
    </div>
    <div v-if="resendVerification">
      <el-form
        :model="loginRequest"
        label-position="top"
        @submit.prevent.native="resendVerificationCode"
      >
        <el-form-item label="邮箱地址">
          <el-input v-model="email" :required="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resendVerificationCode"
            >重新发送激活链接</el-button
          >
          <el-button @click="resendVerification = false" class="float-right"
            >登录页面</el-button
          >
        </el-form-item>
      </el-form>
      <div>
        <b-alert show v-if="this.message" variant="danger">
          {{ this.message }}
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "Login.vue",
  data() {
    return {
      loginRequest: {
        username: "",
        password: ""
      },
      message: "",
      errors: {},
      successMessage: "",
      forgotPassword: false,
      resendVerification: false,
      email: ""
    };
  },
  props: {
    redirect: {
      type: String,
      required: false,
      default: ""
    }
  },
  methods: {
    ...mapMutations(["setLoading"]),
    login: function() {
      this.errors = {};
      this.message = "";
      this.setLoading(true);
      this.$store
        .dispatch("login", this.loginRequest)
        .then(res => {
          if (res.status === 201) {
            this.setLoading(false);
            this.successMessage =
              this.redirect != "" ? "已成功登录,跳转中..." : "已成功登录";
            this.$message({
              showClose: true,
              message: this.successMessage,
              type: "success"
            });
            let self = this;
            setTimeout(function() {
              if (
                self.redirect === "" ||
                self.$router.currentRoute.fullPath === self.redirect
              )
                return;
              self.$router.push(self.redirect);
            }, 2000);
            // window.location.href = this.redirect;
          }
        })
        .catch(err => {
          this.setLoading(false);
          if (err.response.data.errors) {
            this.errors = err.response.data.errors;
          } else {
            this.message = err.response.data.message;
          }
        });
    },
    resetPassword: function() {
      this.message = "";
      if (this.email === "") return;
      this.setLoading(true);
      this.$axios
        .post("/password/email", { email: this.email })
        .then(() => {
          this.setLoading(false);
          this.$message({
            showClose: true,
            message: "密码重置邮件已发送",
            type: "success"
          });
          this.successMessage = "密码重置邮件已发送";
          this.forgotPassword = false;
        })
        .catch(() => {
          this.setLoading(false);
          this.message = "网络出错，请稍后重试！";
        });
    },

    resendVerificationCode: function() {
      this.message = "";

      if (this.email === "") return;

      this.setLoading(true);
      var self = this;
      this.$axios
        .post("/verification/resend", { email: this.email })
        .then(() => {
          self.$message({
            showClose: true,
            message: "激活邮件已发送至您的邮箱",
            type: "success"
          });
          self.successMessage = "激活邮件已发送至您的邮箱";
          self.resendVerification = false;
          self.setLoading(false);
        })
        .catch(function() {
          self.setLoading(false);
          self.message = "网络出错，请稍后重试！";
        });
    }
  }
};
</script>
